import React, { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { ApiResponseType, PERMISSION_TYPE, ROLE_TYPE, USER_ACTION_TYPE } from '../../types'
import { createFullName, getCompanyName, getFileExtension, getPrmsnText } from '../../utils'
import { buttonsText } from '../../utils/constants'
import Logo from '../../components/commonComponent/ProfileImage'
import ViewPdf from '../../components/modal/ViewPdf'
import { endPoints } from '../../utils/endpoints'
import { makePostCall } from '../../effects/requests'
interface ProfileInfoProps {
    userData?: any
    handleUpdateUrl?: any
    urlType?: any;
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({ userData, handleUpdateUrl, urlType }) => {

    const isCrewMem = (userData?.user_type === ROLE_TYPE.TYPE_CREW && userData?.permission_type === PERMISSION_TYPE.TYPE_CREW_MEMBER) ? true : false
    const isProductionOwner = (userData?.user_type === ROLE_TYPE.TYPE_CREW && userData?.permission_type === PERMISSION_TYPE.TYPE_PROD_OWNER) ? true : false

    const logo = isProductionOwner ? userData?.owner_profile?.company_logo : isCrewMem ? userData?.profile_image : userData?.supplier_profile?.company_logo
    const name = isCrewMem ? createFullName(userData?.first_name, userData?.last_name) : (userData?.user_type === ROLE_TYPE.TYPE_CREW) ? getCompanyName(userData) : userData?.supplier_profile?.company_name

    const navigate = useNavigate();

    const [selectedPdf, setSelectedPdf] = useState(null);

    const handleNavigate = () => {
        const role = (userData?.user_type === ROLE_TYPE.TYPE_CREW && userData?.permission_type === PERMISSION_TYPE.TYPE_PROD_OWNER) ? 'owner' : 'supplier';
        navigate(`/manage-profile/${role}/${USER_ACTION_TYPE.TYPE_UPDATE}/1`)
    }

    const handleNotificationClick = () => {
        handleUpdateUrl('notifications settings');
    }

    const handleBackClick = () => {
        navigate('/view-profile')
    }

    const handleDownload = (fileURL: any, filename: any) => {
        const pdfAcceptType = ["pdf", 'PDF'];
        const imgAcceptType = ["jpg", "jpeg", "png", "JPG", "JPEG", "PNG"];
        const common = [...imgAcceptType, ...pdfAcceptType];
        const extension = getFileExtension(fileURL);

        if (common.includes(extension)) {
            const name = createFullName(userData?.first_name, userData?.last_name);
            const aws_url = fileURL;
            const url = pdfAcceptType.includes(extension) ? endPoints.WATER_MARK : endPoints.WATER_MARK_IMAGE;
            const payload = { name, aws_url };

            makePostCall(url, payload).then((res: ApiResponseType<any>) => {
                const watermarkedURL = res?.data?.watermarked_url || fileURL;
                downloadFile(watermarkedURL, filename);
            });
        } else {
            downloadFile(fileURL, filename);
        }
    };

    const downloadFile = (fileURL: any, filename: any) => {
        // Create a virtual anchor element
        const anchor = document.createElement('a');
        anchor.href = fileURL;

        // Set the download attribute to specify the file name
        anchor.download = filename;

        // Append the anchor to the body
        document.body.appendChild(anchor);

        // Trigger a click on the anchor to initiate the download
        anchor.click();

        // Remove the anchor from the body
        document.body.removeChild(anchor);
    }

    const cvName = `${createFullName(userData?.first_name, userData?.last_name)}CV.PDF`

    const handleCv = () => {
        setSelectedPdf(userData?.cv_request?.cv)
    }

    return (
        <div className="card-header bg-transparent border-0">
            {urlType === 'notifications settings'
                ?
                <div className='noti-back-btn' onClick={handleBackClick}>
                    <img src={"/assets/images/black-arrow-left-side.svg"} alt="" />
                </div>
                :
                null
            }
            <button className="rigth-button perple-button">
                {userData?.user_type === ROLE_TYPE.TYPE_SUPPLIER
                    ?
                    buttonsText.btnSupplier
                    :
                    getPrmsnText(userData?.permission_type || '')
                }
            </button>
            <div className="edit-profile-cont">
                <div className="img-border">
                    {logo
                        ?
                        <img className="logo-icon" src={logo} alt="" />
                        :
                        <Logo style={{ width: '93px', height: '93px' }} data={name?.[0]} />
                    }
                </div>
                <h3>{name || ''}</h3>
                {((userData?.user_type === ROLE_TYPE.TYPE_SUPPLIER) || isProductionOwner) &&
                    <div className='edit-profile-btn-wrap'>
                        <button className="edit-profile-btn" onClick={handleNavigate} ><img src={"/assets/images/edit.svg"} alt="" />{buttonsText.editProfile}</button>
                        {(userData?.user_type === ROLE_TYPE.TYPE_SUPPLIER && urlType != 'notifications settings') &&
                            <button className="edit-profile-btn" onClick={() => handleNotificationClick()}>
                                <img src={"/assets/images/menu-icon/Notifications.svg"} alt="" />
                                {'Frequency'}
                            </button>
                        }
                    </div>
                }
                {(isCrewMem && userData?.cv_request?.cv_exists) &&
                    <button className="edit-profile-btn" onClick={handleCv}><img style={{ width: 20, height: 20 }} src={"/assets/images/resume_doc.png"} alt="CV" />View MyCV</button>
                }
            </div>
            {selectedPdf &&
                <ViewPdf
                    onClose={() => { setSelectedPdf(null) }}
                    file={selectedPdf}
                    onDownload={() => handleDownload(selectedPdf, cvName)}
                />
            }
        </div>
    )
}

export default ProfileInfo